export const uni2str = (str) => {
  let result = '', strs = str.match(/\\u.{4}/ig)
  if(!strs) return ''

  for(let i=0, len=strs.length; i < len; i++){
    result += String.fromCharCode(strs[i].replace('\\u', '0x'))
  }
  return result
}